import { useEffect, useRef, useState } from "react"

const roles = [
  "Attendee",
  "Speaker",
  "Sponsor",
  "Exhibitor",
  "Volunteer",
  "Delegate",
  "Media",
  "VIP",
  "Crew",
  "Host",
  "Performer",
  "Attendee",
  "Speaker",
  "Sponsor",
  "Exhibitor",
  "Volunteer",
  "Delegate",
  "Media",
  "VIP",
  "Crew",
  "Host",
  "Performer",
]

export default function RolesSlider() {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const [inView, setInView] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true)
          observer.disconnect()
        }
      },
      { threshold: 0.1 }
    )
    if (wrapperRef.current) observer.observe(wrapperRef.current)
    return () => observer.disconnect()
  }, [])

  return (
    <div ref={wrapperRef} className="w-full overflow-hidden py-6 relative">
      <style>{`
          @keyframes roles-marquee {
            0% { transform: translateX(0%); }
            100% { transform: translateX(-100%); }
          }
  
          .roles-track {
            display: flex;
            width: 200%;
          }
  
          .roles-wrapper {
            display: flex;
            animation: roles-marquee 40s linear infinite;
          }
  
          .roles-item {
            white-space: nowrap;
            padding: 0;
            flex-shrink: 0;
            margin-right: 10px;
          }
  
          .roles-pill {
            background: #d2c5ff;
            color: white;
            padding: 0.5rem 1.5rem;
            border-radius: 10px;
            font-size: 1rem;
            font-weight: 500;
          }
        `}</style>

      <div className="roles-track">
        <div className="roles-wrapper" style={{ animationPlayState: inView ? "running" : "paused" }}>
          {roles.map((role, i) => (
            <div key={i} className="roles-item">
              <span className="roles-pill">{role}</span>
            </div>
          ))}
        </div>

        {/* duplicate for seamless loop */}
        <div className="roles-wrapper" aria-hidden="true" style={{ animationPlayState: inView ? "running" : "paused" }}>
          {roles.map((role, i) => (
            <div key={`dup-${i}`} className="roles-item">
              <span className="roles-pill">{role}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
